import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../constants/size'
import { useScreen, useTimeZone } from '../../../hooks'
import { FormModal } from '../../Form'
import { useResizeModal } from '../../Modal'
import { AppointmentFollowUpModal } from '../AppointmentFollowUpModal'

import {
  QA_NAME_APPOINTMENT_FORM_MODAL,
  QA_NAME_APPOINTMENT_FORM_SUBMIT,
} from './AppointmentFormModal.constants'
import { useAppointmentFormSubmit } from './AppointmentFormModal.hooks'
import { getAppointmentFormInitialValues } from './AppointmentFormModal.utils'
import { getAppointmentFormValidationSchema } from './AppointmentFormModal.utils.validation'
import { AppointmentFormModalActions } from './AppointmentFormModalActions'
import { AppointmentFormModalFields } from './AppointmentFormModalFields'

function AppointmentFormModal({
  building,
  emailThread,
  end,
  firstDay,
  lastDay,
  location,
  participants,
  request,
  requestIds,
  resident,
  start,
  title,
  type,
  withEmptySpan,
  onClose,
  onSaved,
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const { isMobileScreenSize } = useScreen()

  const { fullScreen, handleResizeModal } = useResizeModal()

  // Read once: the next full hour must not move under an open form
  const [initialValues] = useState(() =>
    getAppointmentFormInitialValues({
      building,
      emailThread,
      end,
      firstDay,
      lastDay,
      location,
      participants,
      request,
      resident,
      start,
      timezone,
      title,
      type,
      withEmptySpan,
    })
  )

  const [followUpAppointment, setFollowUpAppointment] = useState(null)

  const { handleSubmit } = useAppointmentFormSubmit({
    onClose,
    onFollowUpPrompt: setFollowUpAppointment,
    onSaved,
  })

  return followUpAppointment ? (
    <AppointmentFollowUpModal
      appointment={followUpAppointment}
      onApplied={onSaved}
      onClose={onClose}
    />
  ) : (
    <FormModal
      Fields={AppointmentFormModalFields}
      containerProps={{
        boxSize: SIZE.X_LARGE,
        isFullScreen: isMobileScreenSize || fullScreen,
        qaName: QA_NAME_APPOINTMENT_FORM_MODAL,
        onResize: isMobileScreenSize ? undefined : handleResizeModal,
      }}
      formBodyProps={{
        Actions: AppointmentFormModalActions,
        contentProps: { isFullScreen: isMobileScreenSize || fullScreen },
        submitQaName: QA_NAME_APPOINTMENT_FORM_SUBMIT,
        withNotifications: true,
      }}
      formFieldsProps={{ requestIds }}
      formTitle='Appointment.FormNewTitleKey'
      initialValues={initialValues}
      validationSchema={getAppointmentFormValidationSchema(t)}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default AppointmentFormModal
